// extracted by mini-css-extract-plugin
export var breadCrumbContainerWrapper = "styles-module--breadCrumbContainerWrapper--1ll8b";
export var breadCrumbContainer = "styles-module--breadCrumbContainer--wPtRp";
export var breadCrumbItem = "styles-module--breadCrumbItem--2-EQP";
export var breadCrumbSeparator = "styles-module--breadCrumbSeparator--33rIe";
export var applyVerticalAlign = "styles-module--applyVerticalAlign--3xbxI";
export var breadCrumbLastItem = "styles-module--breadCrumbLastItem--3i3Fb";